<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:getFiltersParams="getFiltersParams"
		:reportFormUrl="reportFormUrl">
		<FiltersBox slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportformSupply/orderDetail.js'
import { orderMenu } from '@/js/reportformSupply/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrap.vue'
import FiltersBox from '@/components/reportformSupply/orderDetail/FiltersBox.vue'
import { mixinReportAuth } from '@/js/mixins/reportform/authComp.js'
export default {
	name: 'MidOrderDetail',
	components: {
		reportFormWrap,
		FiltersBox
	},
	mixins: [mixinReportAuth],
	data () {
		return {
			reportid: 'MID_DPXQ_121011',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlNVPM}/reportScheme/midShopSaleOrderDetailReport`,
			orderMenu: orderMenu
		}
	},
	mounted () {
		this.$refs.reportFormWrap.initReportForm()
	},
	methods: {
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		}
	}
}
</script>
